import React from 'react';
import style from './App.scss';
import { Text } from '../PageElements/Text';

export const OpenNavigationButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className={style.mobileNavigationBtn}>
      <Text weight="bold" light>
        Menu
      </Text>
    </button>
  );
};
